import { useContext, useEffect } from "react";
import { usePrevious } from "../../../../../../../../helpers/useReadStateSuccess";
import { TransactionCreateContext } from "../TransactionCreateProvider";
import ReconciliationActions from 'bukku/redux/Reconciliation/actions';
import { CLOSE_PANEL_ANIMATION_TIME, useClosePanel } from "./useClosePanel";
import { useDispatch } from "react-redux";

const {
    addLedger,
    setLedger,
} = ReconciliationActions;

export const LEDGER_FADE_IN_TIME = 400; // in ms

export const useCreateTransactionSuccess = (createTransactionState, createTransactionResult) => {
    const transactionCreateContext = useContext(TransactionCreateContext);
    const { contextState, contextProps } = transactionCreateContext;
    const {
        isCreatePanelVisible,
    } = contextState;
    const {
        setCurrentPage,
    } = contextProps;
    const handleClosePanel = useClosePanel();
    const dispatch = useDispatch();

    const prevCreateTransactionState = usePrevious(createTransactionState);
    useEffect(() => {
        if (prevCreateTransactionState === 'request' && createTransactionState === 'success') {
            // close modal
            handleClosePanel(); // takes 200ms for panel to fade out
            setTimeout(() => {
                // add to first row and reset pagination to page 1
                dispatch(addLedger({...createTransactionResult, isFadingIn: true}, 0));
                setCurrentPage(1);
            }, CLOSE_PANEL_ANIMATION_TIME); // additional 100ms for reaction time

            setTimeout(() => {
                dispatch(setLedger({...createTransactionResult, isFadingIn: false, isNewlyCreated: true}));
            }, CLOSE_PANEL_ANIMATION_TIME + LEDGER_FADE_IN_TIME);
        }
    }, [
        prevCreateTransactionState, createTransactionState, createTransactionResult, // reduxState
        isCreatePanelVisible, // contextState
        setCurrentPage, // contextProps
        handleClosePanel, // hooks
        dispatch,
    ]);
};
